import { render } from "./vehicle-one-col-layout.vue?vue&type=template&id=5e38db94"
import script from "./vehicle-one-col-layout.vue?vue&type=script&lang=js"
export * from "./vehicle-one-col-layout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__